import { jsx } from 'react/jsx-runtime';
import WhenValidGrandChildren from '../../../utility/WhenValidGrandChildren.mjs';
import BaseHelperText from '../BaseHelperText.mjs';
import { useTextAreaContext } from './context.mjs';

const TEXT_AREA_HELPER_TEXT_NAME = "TextAreaHelperText";
function HelperText({
  icon: iconFromProps,
  id,
  ...props
}) {
  const {
    state,
    disabled,
    setDescribedBy
  } = useTextAreaContext(TEXT_AREA_HELPER_TEXT_NAME);
  return /* @__PURE__ */ jsx(WhenValidGrandChildren, { children: /* @__PURE__ */ jsx(
    BaseHelperText,
    {
      ...props,
      state,
      disabled,
      setDescribedBy
    }
  ) });
}

export { HelperText as default };
//# sourceMappingURL=HelperText.mjs.map
